{
  "field.deviceName.name": "Имя устройства",
  "field.deviceName.help": "Читаемый идентификатор устройства. Используется в журналах и отображении статуса соединения.",
  "field.deviceName.placeholder": "Введите имя устройства",

  "field.baudRate.name": "Скорость (бод)",
  "field.baudRate.help": "Скорость последовательной связи в битах в секунду. Должна соответствовать настроенной скорости устройства.",
  "field.baudRate.option.9600": "9600",
  "field.baudRate.option.19200": "19200",
  "field.baudRate.option.38400": "38400",
  "field.baudRate.option.57600": "57600",
  "field.baudRate.option.115200": "115200",

  "field.timeout.name": "Тайм-аут (мс)",
  "field.timeout.help": "Максимальное время ожидания ответа перед тем, как операция будет считаться неудачной.",

  "field.autoReconnect.name": "Авто-переподключение",
  "field.autoReconnect.help": "Автоматически пытаться переподключиться при неожиданной потере соединения.",

  "field.retryCount.name": "Количество повторов",
  "field.retryCount.help": "Сколько раз повторить неудачную операцию перед тем, как сдаться.",

  "field.logLevel.name": "Уровень журнала",
  "field.logLevel.help": "Уровень детализации журналирования устройства. Debug показывает все сообщения, Error — только ошибки.",
  "field.logLevel.option.debug": "Отладка",
  "field.logLevel.option.info": "Информация",
  "field.logLevel.option.warning": "Предупреждение",
  "field.logLevel.option.error": "Ошибка"
}
